import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "TMS for Depression After Medication Failure | Neuro Wellness TMS Centers of America",
  description:
    "When antidepressants haven't worked: learn about TMS, SAINT, and other treatment options for depression after medication failure.",
  canonical: "/tms-for-depression-after-medication-failure",
  keywords:
    "TMS after medication failure, depression medication not working, TMS when antidepressants fail, treatment-resistant depression Florida",
};

const relatedLinks = [
  {
    title: "TMS for Treatment-Resistant Depression",
    href: "/tms-for-treatment-resistant-depression",
  },
  { title: "TMS for Depression", href: "/services/depression" },
  { title: "SAINT TMS", href: "/saint" },
  { title: "SPRAVATO Overview", href: "/services/spravato" },
  { title: "Am I a Candidate?", href: "/am-i-a-candidate" },
];

export default function TmsForDepressionAfterMedicationFailure() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="After Medication Failure"
      title="TMS for Depression After Medication Failure"
      subtitle="If antidepressants haven't given you the relief you need, you're not out of options. TMS works through a different mechanism entirely."
    >
      <DecisionSection heading="When medication hasn't worked">
        <p>
          You could probably name the medications you've tried. The one that
          made you gain weight. The one that flattened everything. The one that
          worked for a few months and then stopped.
        </p>
        <p>
          If you've tried two or more antidepressants without adequate relief,
          you're not failing at treatment. The treatment has been failing to
          reach you. Depression that doesn't respond to standard antidepressants
          has a name — treatment-resistant depression — and treatments were
          developed specifically for it.
        </p>
      </DecisionSection>

      <DecisionSection heading="Why TMS is different">
        <p>
          Oral antidepressants work by changing chemical signaling throughout
          your entire body. TMS works differently — it uses focused magnetic
          pulses to stimulate a specific area of the brain involved in mood
          regulation. Nothing enters your body. There are no systemic side
          effects like weight gain or sexual dysfunction.
        </p>
        <p>
          It's FDA-cleared, non-invasive, and performed in an outpatient
          setting. You stay awake and can drive yourself home.
        </p>
      </DecisionSection>

      <DecisionSection heading="Treatment options">
        <DecisionList
          items={[
            "Standard TMS — 5 days/week for ~6 weeks, FDA-cleared",
            "SAINT accelerated TMS — 5-day protocol with fMRI targeting, FDA-cleared",
            "SPRAVATO (esketamine) — FDA-approved for TRD, works on a different brain system",
            "IV ketamine infusions — rapid-acting, off-label",
            "Ketamine-assisted psychotherapy (KAP)",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Your next step">
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link to="/contactus" className="text-accent hover:underline">
            schedule a consultation
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
